import {
  AgentType,
  BoardSearchDetail,
  CalendarBox,
  CalendarIcon,
  ColSpan0, ColSpan1, ColSpan2,
  ColSpan4,
  ColTitle,
  CustomDatePicker,
  DateContainer,
  Input,
  RangePicker,
  ResetButton,
  RowSpan,
  SearchInput,
  selectStyle,
  Span2,
} from "../../assets/GlobalStyles";
import ko from "date-fns/locale/ko";
import {HorizontalRule} from "../common/Common";
import React, {useEffect, useState} from "react";
import {
  getLastDay,
  getLastMonth,
  getLastNinetyDay,
  getLastOneEightyDay,
  getLastThirtyDay,
  getLastWeekDay,
  getThisMonth,
  getToDay
} from "../../common/DateUtils";
import Checkbox from "../common/Checkbox";
import Select from "react-select";
import {SearchAdvertiser} from "../common/SearchAdvertiser";
import {useParams} from "react-router-dom";
import * as PropTypes from "prop-types";
import moment from "moment";
import {light} from "../../assets/theme";
import styled from "styled-components";
import {ReportCalendarContainer} from "../../pages/reports/ReportSharedLayout";

ResetButton.propTypes = {onClick: PropTypes.func};

export function PlatformCondition(props) {
  const [dateActive,setDateActive] = useState('thisMonth')
  const {searchCondition, setSearchCondition, handleTableData, searchType} = props;
  const [dateRange, setDateRange] = useState([ new Date(getThisMonth().startDay), new Date(getToDay())]);
  const [startDate, endDate] = dateRange;
  const params = useParams()
  const mainColor = light.color.topicColor;
  /**
   * 날짜 레인지 선택
   * @param rangeType
   */
  const handleRangeDate = (rangeType) => {
    setDateActive(rangeType)
    if (rangeType === 'thisMonth') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getThisMonth().startDay,
        searchEndDate: getThisMonth().endDay
      })
      setDateRange([new Date(getThisMonth().startDay), new Date(getThisMonth().endDay)])
    } else if (rangeType === 'lastMonth') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastMonth().startDay,
        searchEndDate: getLastMonth().endDay
      })
      setDateRange([new Date(getLastMonth().startDay), new Date(getLastMonth().endDay)])
    } else if (rangeType === 'today') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getToDay(),
        searchEndDate: getToDay()
      })
      setDateRange([new Date(), new Date()])
    } else if (rangeType === 'lastDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastDay(),
        searchEndDate: getLastDay()
      })
      setDateRange([new Date(getLastDay()), new Date(getLastDay())])
    } else if (rangeType === 'lastWeekDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastWeekDay().startDay,
        searchEndDate: getLastWeekDay().endDay
      })
      setDateRange([new Date(getLastWeekDay().startDay), new Date(getLastWeekDay().endDay)])
    } else if (rangeType === 'lastThirtyDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastThirtyDay().startDay,
        searchEndDate: getLastThirtyDay().endDay
      })
      setDateRange([new Date(getLastThirtyDay().startDay), new Date(getLastThirtyDay().endDay)])
    } else if (rangeType === 'lastNinetyDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastNinetyDay().startDay,
        searchEndDate: getLastNinetyDay().endDay
      })
      setDateRange([new Date(getLastNinetyDay().startDay), new Date(getLastNinetyDay().endDay)])
    }
    else if (rangeType === 'lastOneEightyDay') {
      setSearchCondition({
        ...searchCondition,
        searchStartDate: getLastOneEightyDay().startDay,
        searchEndDate: getLastOneEightyDay().endDay
      })
      setDateRange([new Date(getLastOneEightyDay().startDay), new Date(getLastOneEightyDay().endDay)])
    }
    //call 때려
  }
  const handelChangeDateRange = (date) => {
    if(date[1] !== null){
      setSearchCondition({
        ...searchCondition,
        searchStartDate: moment(date[0]).format('YYYY-MM-DD'),
        searchEndDate: moment(date[1]).format('YYYY-MM-DD')
      })
      setDateActive('')
    }
    setDateRange(date)
  }
  const handleSearchType = (selectSearchType) => {
    if(selectSearchType.value === 'DEFAULT'){
      setSearchCondition({
        ...searchCondition,
        searchType: selectSearchType.value,
        keyword: ''
      })
    }else {
      setSearchCondition({
        ...searchCondition,
        searchType: selectSearchType.value
      })
    }
  }

  const handleSearchValue = (event) => {
    setSearchCondition({
      ...searchCondition,
      keyword: event.target.value
    })
  }

  const handleSearchAdverResult = (data) => {
    setSearchCondition({
      ...searchCondition,
      username: data.username
    })
    // retrieveProduct({...searchCondition,username: data.username}).then(response =>{
    //   setProductData(response)
    // })
  }

  const handleResetCondition = () => {
    const resetCondition = {
      ...searchCondition,
      searchStartDate: getThisMonth().startDay,
      searchEndDate: getThisMonth().endDay,
      searchType: 'DEFAULT',
      keyword: '',
      username: '',
      currentPage: 1
    }

    setDateActive('thisMonth')
    setDateRange([
      new Date(getThisMonth().startDay),
      new Date(getThisMonth().endDay)
    ])
    setSearchCondition(resetCondition)
  }

  return (
    <>
      {params.id !== 'conversionManage' &&
            <RowSpan style={{justifyContent: 'flex-start'}}>
              <ColSpan0>
                <Span2>광고주 설정</Span2>
                <Input style={{width: 300}} type={'text'} value={searchCondition.username} readOnly/>
                <SearchAdvertiser title={'검색'} onSubmit={handleSearchAdverResult}/>
              </ColSpan0>
            </RowSpan>
      }
      <RowSpan style={{marginTop: 0}}>
        <BoardSearchDetail style={{marginTop: 10}}>
          <div style={{marginRight: 10}}>
            <RowSpan style={{justifyContent: 'flex-start', marginTop:0}}>
              <ColSpan4>
                  {/*<Span2>기간</Span2>*/}
                    <DateContainer style={{marginRight: 0}}>
                      <CalendarBox>
                        <CalendarIcon/>
                      </CalendarBox>
                      <CustomDatePicker
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        maxDate={new Date()}
                        onChange={(date) => handelChangeDateRange(date)}
                        dateFormat="yyyy-MM-dd"
                        locale={ko}
                        isClearable={false}
                        monthsShown={2}
                        openToDate={endDate}
                      />
                    </DateContainer>
                <ColSpan0>
                  <div>
                    <RangePicker>
                      <div onClick={() => handleRangeDate('thisMonth')} style={dateActive==='thisMonth'?{color: mainColor, fontWeight:"bold"}:null}>이번달</div>
                      <HorizontalRule style={{margin: "0 10px"}}/>
                      <div onClick={() => handleRangeDate('lastMonth')} style={dateActive==='lastMonth'?{color: mainColor, fontWeight:"bold"}:null}>지난달</div>
                      <HorizontalRule style={{margin: "0 10px"}}/>
                      <div onClick={() => handleRangeDate('today')} style={dateActive==='today'?{color: mainColor, fontWeight:"bold"}:null}>오늘</div>
                      <HorizontalRule style={{margin: "0 10px"}}/>
                      <div onClick={() => handleRangeDate('lastDay')} style={dateActive==='lastDay'?{color: mainColor, fontWeight:"bold"}:null}>어제</div>
                      <HorizontalRule style={{margin: "0 10px"}}/>
                      <div onClick={() => handleRangeDate('lastWeekDay')} style={dateActive==='lastWeekDay'?{color: mainColor, fontWeight:"bold"}:null}>지난7일</div>
                      <HorizontalRule style={{margin: "0 10px"}}/>
                      <div onClick={() => handleRangeDate('lastThirtyDay')} style={dateActive==='lastThirtyDay'?{color: mainColor, fontWeight:"bold"}:null}>지난30일</div>
                      <HorizontalRule style={{margin: "0 10px"}}/>
                      <div onClick={() => handleRangeDate('lastNinetyDay')} style={dateActive==='lastNinetyDay'?{color: mainColor, fontWeight:"bold"}:null}>지난90일</div>
                      {/*<HorizontalRule style={{margin: "0 10px"}}/>*/}
                      {/*<div onClick={() => handleRangeDate('lastOneEightyDay')} style={dateActive==='lastOneEightyDay'?{color: mainColor}:null}>지난180일</div>*/}
                    </RangePicker>
                  </div>
                </ColSpan0>
              </ColSpan4>
            </RowSpan>
            <RowSpan style={{justifyContent: 'flex-start'}}>
                <ColSpan4>
                  {/*<Span2>검색어</Span2>*/}
                    <Select options={searchType}
                            value={searchCondition.searchType !== '' ? searchType.find(value => value.value === searchCondition.searchType) : searchType[0]}
                            onChange={handleSearchType}
                            isSearchable={false}
                            width={133}
                            styles={selectStyle}
                    />
                    <SearchInput>
                      <input type={'text'}
                             placeholder={'검색어를 입력해주세요.'}
                             readOnly={searchCondition.searchType === 'DEFAULT' || searchCondition.searchType.id === 0}
                             value={searchCondition.keyword}
                             onChange={handleSearchValue}
                             onKeyDown={e => (e.key === 'Enter') && handleTableData()}
                      />
                    </SearchInput>
                </ColSpan4>
        </RowSpan>
          </div>
          <PlatformConditionFooter>
            <PlatformResetButton type="button" onClick={handleResetCondition}>초기화</PlatformResetButton>
            <PlatformApplyButton type="button" onClick={handleTableData}>적용</PlatformApplyButton>
          </PlatformConditionFooter>
        </BoardSearchDetail>
      </RowSpan>
    </>
  )
}

const paymentSearchSelectStyle = {
  control: (provided, state) => ({
    ...provided,
    minHeight: 40,
    height: 40,
    borderColor: state.isFocused ? '#f5811f' : '#e5e5e5',
    borderRadius: 6,
    backgroundColor: state.isDisabled ? '#f5f5f5' : '#fff',
    boxShadow: 'none',
    fontSize: 13,
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    '&:hover': {borderColor: state.isDisabled ? '#e5e5e5' : '#f1d4c2'}
  }),
  valueContainer: provided => ({...provided, height: 40, padding: '0 11px'}),
  input: provided => ({...provided, margin: 0, padding: 0}),
  indicatorsContainer: provided => ({...provided, height: 40}),
  indicatorSeparator: () => ({display: 'none'}),
  dropdownIndicator: provided => ({...provided, padding: '0 9px', color: '#888'}),
  singleValue: provided => ({...provided, color: '#444'}),
  placeholder: provided => ({...provided, color: '#aaa'}),
  menu: provided => ({
    ...provided,
    zIndex: 40,
    overflow: 'hidden',
    border: '1px solid #e5e5e5',
    borderRadius: 6,
    boxShadow: '0 8px 24px rgba(0,0,0,.1)'
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '9px 11px',
    backgroundColor: state.isSelected ? '#fff4e8' : state.isFocused ? '#fffaf6' : '#fff',
    color: state.isSelected ? '#f5811f' : '#555',
    fontSize: 13,
    cursor: 'pointer'
  })
}

export function PaymentCondition(props) {
  const {searchCondition, setSearchCondition, handleTableData, handleReset, searchType} = props
  const [dateRange, setDateRange] = useState([new Date(getThisMonth().startDay), new Date(getToDay())]);
  const [startDate, endDate] = dateRange
  const [dateActive, setDateActive] = useState('thisMonth')
  const [isCheckedAll, setIsCheckedAll] = useState(true)
  const [searchTypeSelect] = useState(searchType)
  const [, setSearchSelected] = useState(searchTypeSelect[0])

  const params = useParams()

  const handelChangeDateRange = (date) => {
    if(date[1] !== null){
      setSearchCondition({
        ...searchCondition,
        startAt: moment(date[0]).format('YYYY-MM-DD'),
        endAt: moment(date[1]).format('YYYY-MM-DD')
      })
    }
    setDateRange(date)
  }

  const handleRangeDate = (rangeType) => {
    const ranges = {
      thisMonth: getThisMonth(),
      lastMonth: getLastMonth(),
      today: {startDay: getToDay(), endDay: getToDay()},
      lastDay: {startDay: getLastDay(), endDay: getLastDay()},
      lastWeekDay: getLastWeekDay(),
      lastThirtyDay: getLastThirtyDay(),
      lastNinetyDay: getLastNinetyDay()
    }
    const selectedRange = ranges[rangeType]

    if (!selectedRange) return

    setDateActive(rangeType)
    const nextRange = [
      new Date(selectedRange.startDay),
      new Date(selectedRange.endDay)
    ]
    setDateRange(nextRange)
    setSearchCondition({
      ...searchCondition,
      startAt: selectedRange.startDay,
      endAt: selectedRange.endDay
    })
  }

  useEffect(() => {
    if(searchCondition.statusList.length === 2 && params.id !== 'advertisingPayments') {
      setIsCheckedAll(true)
    } else if(searchCondition.statusList.length === 4 && params.id === 'advertisingPayments') {
      setIsCheckedAll(true)
    } else {
      setIsCheckedAll(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[searchCondition.statusList.length])
  /**
   * 이벤트 유형 선택
   * @param date
   */

  const handleChangeCheckAll = (event) => {
    if(event.target.checked){
      setSearchCondition({
        ...searchCondition,
        statusList: ['PAYMENT_COMPLETED', 'PAYMENT_FAILED']
      })
    } else{
      setSearchCondition({
        ...searchCondition,
        statusList: []
      })
    }
    setIsCheckedAll(event.target.checked)
  }

  const handleChangeCostCheckAll = (event) => {
    if(event.target.checked){
      setSearchCondition({
        ...searchCondition,
        statusList: ['GIVEN_BY_ADMIN', 'TAKEN_BY_ADMIN','REFUND_REQUEST_OF_USER','REFUNDED_BY_ADMIN']
      })
    } else{
      setSearchCondition({
        ...searchCondition,
        statusList: []
      })
    }
    setIsCheckedAll(event.target.checked)
  }
  //체크박스 핸들링
  const handleChangeChecked = (event) => {
    if(event.currentTarget.checked){
      setSearchCondition({
        ...searchCondition,
        statusList: searchCondition.statusList.concat(event.currentTarget.id)
      })
    }else{
      setSearchCondition({
        ...searchCondition,
        statusList: searchCondition.statusList.filter(id => id !== event.currentTarget.id)
      })
    }
  }
  const handleSearchType = (selectSearchType) => {

    if(selectSearchType.value === 'ALL') {
      setSearchCondition({
        ...searchCondition,
        searchType: selectSearchType.value,
        search: ''
      })
    } else {
      setSearchCondition({
        ...searchCondition,
        searchType: selectSearchType.value
      })
    }
    setSearchSelected(selectSearchType)
  }

  const handlePaymentSearchValue = (event) => {
    setSearchCondition({
      ...searchCondition,
      search: event.target.value
    })
  }
  const handleResetCondition = () => {
    const resetCondition = {
      ...searchCondition,
      startAt: getThisMonth().startDay,
      endAt: getThisMonth().endDay,
      statusList: params.id === 'advertisingPayments'
          ? ['GIVEN_BY_ADMIN', 'TAKEN_BY_ADMIN', 'REFUND_REQUEST_OF_USER', 'REFUNDED_BY_ADMIN']
          : ['PAYMENT_COMPLETED', 'PAYMENT_FAILED'],
      searchType: 'ALL',
      search: ''
    }
    setDateRange([new Date(getThisMonth().startDay), new Date(getThisMonth().endDay)])
    setDateActive('thisMonth')
    setIsCheckedAll(true)
    setSearchCondition(resetCondition)
    if (handleReset) handleReset(resetCondition)
  }
  return (
        <PaymentFilterForm>
            <RowSpan style={{justifyContent: 'flex-start'}}>
              <ColSpan1>
                <ColTitle><span>기간</span></ColTitle>
                <div style={{width:'100%'}}>
                    <DateContainer style={{marginRight: 0}}>
                      <CalendarBox>
                        <CalendarIcon/>
                      </CalendarBox>
                      <CustomDatePicker
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        maxDate={new Date(getToDay())}
                        onChange={(date) => {
                          setDateActive('')
                          handelChangeDateRange(date)
                        }}
                        dateFormat="yyyy-MM-dd"
                        locale={ko}
                        isClearable={false}
                        monthsShown={2}
                        openToDate={startDate}
                        focusSelectedMonth
                        calendarContainer={props => (
                          <ReportCalendarContainer
                              {...props}
                              active={dateActive}
                              onSelect={handleRangeDate}
                          />
                        )}
                      />
                    </DateContainer>
                </div>
              </ColSpan1>
                <ColSpan2>
                  <ColTitle><span>신청 상태</span></ColTitle>
                    <AgentType>
                      {params.id === 'advertisingPayments' &&
                        <>
                          <Checkbox label={'전체'}
                                    type={'c'}
                                    id={'ALL'}
                                    isChecked={isCheckedAll}
                                    onChange={handleChangeCostCheckAll}
                          />
                          <Checkbox label={'광고비 지급'}
                                    type={'c'}
                                    id={'GIVEN_BY_ADMIN'}
                                    isChecked={searchCondition.statusList.includes('GIVEN_BY_ADMIN')}
                                    onChange={handleChangeChecked}/>
                          <Checkbox label={'광고비 차감'}
                                    type={'c'}
                                    id={'TAKEN_BY_ADMIN'}
                                    isChecked={searchCondition.statusList.includes('TAKEN_BY_ADMIN')}
                                    onChange={handleChangeChecked}/>
                          <Checkbox label={'환불 신청'}
                                    type={'c'}
                                    id={'REFUND_REQUEST_OF_USER'}
                                    isChecked={searchCondition.statusList.includes('REFUND_REQUEST_OF_USER')}
                                    onChange={handleChangeChecked}/>
                          <Checkbox label={'환불 완료'}
                                    type={'c'}
                                    id={'REFUNDED_BY_ADMIN'}
                                    isChecked={searchCondition.statusList.includes('REFUNDED_BY_ADMIN')}
                                    onChange={handleChangeChecked}/>
                        </>
                      }
                      {params.id === 'paymentManage' &&
                        <>
                          <Checkbox label={'전체'}
                                    type={'c'}
                                    id={'ALL'}
                                    isChecked={isCheckedAll}
                                    onChange={handleChangeCheckAll}
                          />
                          <Checkbox label={'결제 완료'}
                                    type={'c'}
                                    id={'PAYMENT_COMPLETED'}
                                    isChecked={searchCondition.statusList.includes('PAYMENT_COMPLETED')}
                                    onChange={handleChangeChecked}/>
                          <Checkbox label={'결제 실패'}
                                    type={'c'}
                                    id={'PAYMENT_FAILED'}
                                    isChecked={searchCondition.statusList.includes('PAYMENT_FAILED')}
                                    onChange={handleChangeChecked}/>
                        </>
                      }
                    </AgentType>
                </ColSpan2>
            </RowSpan>
            <RowSpan style={{justifyContent: 'flex-start'}}>
              <ColSpan2>
                <ColTitle><span>검색</span></ColTitle>
                  <Select options={searchType}
                          value={searchCondition.searchType.value !== '' ? searchType.find(value => value.value === searchCondition.searchType) : searchType[0]}
                          onChange={handleSearchType}
                          isSearchable={false}
                          width={133}
                          styles={paymentSearchSelectStyle}
                  />
                  <SearchInput>
                    <input type={'text'}
                           placeholder={'검색어를 입력해주세요.'}
                           value={searchCondition.search}
                           onChange={handlePaymentSearchValue}
                           readOnly={searchCondition.searchType === 'ALL'}
                           style={{marginRight: 0}}
                           onKeyDown={e => (e.key === 'Enter') && handleTableData()}
                    />
                  </SearchInput>
              </ColSpan2>
            </RowSpan>
            <PaymentConditionFooter>
              <PaymentConditionActions>
                <PaymentResetButton type="button" onClick={handleResetCondition}>초기화</PaymentResetButton>
                <PaymentApplyButton type="button" onClick={handleTableData}>적용</PaymentApplyButton>
              </PaymentConditionActions>
            </PaymentConditionFooter>
        </PaymentFilterForm>
  )
}

const PaymentFilterForm = styled(BoardSearchDetail)`
  width:100%;margin:0 !important;padding:0 !important;border:0 !important;background:transparent !important;

  > ${RowSpan} {
    display:grid;
    grid-template-columns:minmax(260px,.9fr) minmax(420px,1.5fr);
    align-items:end;
    gap:18px;
    margin:0 0 18px !important;
  }

  > ${RowSpan}:nth-child(2) {
    grid-template-columns:minmax(420px,1fr);
    margin-bottom:0 !important;
    padding-top:18px;
    //border-top:1px solid #eeeeee;
  }

  > ${RowSpan}:nth-child(2) > ${ColSpan2} {
    display:grid;
    grid-template-columns:130px minmax(0,1fr);
    align-items:end;
    gap:8px;
  }

  > ${RowSpan}:nth-child(2) > ${ColSpan2} > ${ColTitle} {
    grid-column:1 / -1;
  }

  ${ColSpan1}, ${ColSpan2} {
    display:flex;width:100%;min-width:0;align-items:stretch;flex-direction:column;gap:8px;
  }

  ${ColTitle} {padding:0;color:#555;font-size:var(--font-size-13);font-weight:700;text-align:left;}
  ${DateContainer} {
    width:360px;max-width:100%;height:42px;min-height:42px;overflow:visible;
    border:1px solid #dfe3e6;border-radius:8px;background:#fff;
    transition:border-color .14s ease,box-shadow .14s ease;
  }
  ${DateContainer}:hover {border-color:#f1d4c2;}
  ${DateContainer}:focus-within {border-color:#f5811f;box-shadow:0 0 0 3px rgba(245,129,31,.13);}
  ${CalendarBox} {
    width:42px;min-width:42px;min-height:40px;border-right:1px solid #f1e4da;
    border-radius:7px 0 0 7px;background:#fff8f1;
  }
  ${CalendarIcon} {width:16px;height:18px;background-size:16px 18px;opacity:.82;}
  ${DateContainer} .react-datepicker-wrapper,
  ${DateContainer} .react-datepicker__input-container {width:100%;height:40px;}
  ${DateContainer} input[type="text"] {
    width:100%;height:40px !important;box-sizing:border-box;padding:0 12px !important;
    border:0 !important;border-radius:0 7px 7px 0;background:#fff !important;
    color:#444;font-size:var(--font-size-13) !important;font-weight:600;cursor:pointer;
    box-shadow:none !important;
  }
  ${DateContainer} .react-datepicker {overflow:hidden;border:1px solid #e5e8eb;border-radius:9px;box-shadow:0 10px 28px rgba(31,41,55,.14);font-size:var(--font-size-13);}
  ${DateContainer} .react-datepicker__header {border-bottom-color:#f1e4da;background:#fff8f1;}
  ${DateContainer} .react-datepicker__day--selected,
  ${DateContainer} .react-datepicker__day--in-range,
  ${DateContainer} .react-datepicker__day--keyboard-selected {background:#f5811f;color:#fff;}
  ${DateContainer} .react-datepicker__day--in-selecting-range {background:#ffe8d2;color:#d96500;}
  ${AgentType} {min-height:42px;box-sizing:border-box;align-items:center;padding:8px 12px;border:1px solid #dfe3e6;border-radius:8px;background:#fff;}
  ${SearchInput} {width:100%;}

  @media(max-width:900px){
    > ${RowSpan}, > ${RowSpan}:nth-child(2){grid-template-columns:1fr;}
    > ${RowSpan}:nth-child(2) > ${ColSpan2}{grid-template-columns:1fr;}
  }
`;

const PaymentConditionActions = styled.div`display:flex;align-items:center;justify-content:flex-end;gap:8px;`;
const PaymentConditionFooter = styled.div`
  display:flex;
  width:100%;
  justify-content:flex-end;
  margin-top:16px;
`;
const PlatformApplyButton = styled.button`
  && {
    display:inline-flex;min-width:72px;height:36px;align-items:center;justify-content:center;
    padding:0 14px;border:1px solid #f5811f;border-radius:6px;background:#fff4e8;
    color:#f5811f;font-size:var(--font-size-13);font-weight:700;cursor:pointer;
  }
  &&:hover:not(:disabled){background:#ffe8d2;color:#f5811f;}
  &&:disabled{border-color:#ddd;background:#f5f5f5;color:#aaa;cursor:not-allowed;}
`;
const PlatformConditionFooter = styled.div`
  display:flex;
  width:100%;
  flex:0 0 100%;
  align-items:center;
  justify-content:flex-end;
  gap:8px;
  margin-top:16px;
`;
const PlatformResetButton = styled.button`
  && {
    min-width:72px;height:36px;padding:0 12px;border:1px solid #dfe3e7;
    border-radius:6px;background:#fff;color:#666;font-size:var(--font-size-13);font-weight:700;cursor:pointer;
  }
  &&:hover:not(:disabled){border-color:#f1d4c2;background:#fffaf6;color:#f5811f;}
  &&:disabled{background:#f5f5f5;color:#bbb;cursor:not-allowed;}
`;
const PaymentResetButton = styled.button`
  &&{min-width:72px;height:36px;padding:0 12px;border:1px solid #dfe3e7;border-radius:6px;background:#fff;color:#666;font-size:var(--font-size-13);font-weight:700;cursor:pointer;}
  &&:hover{border-color:#f1d4c2;background:#fffaf6;color:#f5811f;}
`;
const PaymentApplyButton = styled.button`
  &&{display:inline-flex;min-width:72px;height:36px;align-items:center;justify-content:center;padding:0 14px;border:1px solid #f5811f;border-radius:6px;background:#fff4e8;color:#f5811f;font-size:var(--font-size-13);font-weight:700;cursor:pointer;}
  &&:hover:not(:disabled){background:#ffe8d2;color:#f5811f;}
  &&:disabled{border-color:#ddd;background:#f5f5f5;color:#aaa;cursor:not-allowed;}
`;
